import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=07724df1&scoped=true&"
import script from "./OrderReview.vue?vue&type=script&lang=js&"
export * from "./OrderReview.vue?vue&type=script&lang=js&"
import style0 from "./OrderReview.vue?vue&type=style&index=0&id=07724df1&prod&scoped=true&lang=less&"
import style1 from "./OrderReview.vue?vue&type=style&index=1&id=07724df1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07724df1",
  null
  
)

export default component.exports